import { render, staticRenderFns } from "./MembershipGeneralSettings.vue?vue&type=template&id=90887b76&"
import script from "./MembershipGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./MembershipGeneralSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports